import { useAuthStore } from '../stores/useAuthStore';
import { useServerStore } from '../stores/useServerStore';
import { deriveProjectAuthority, type ProjectAuthority } from '../lib/projectAuthority';

export function useProjectAuthority(guildId?: string | null): ProjectAuthority {
  const accountId = useAuthStore((state) => state.currentUser?.id ?? null);
  const activeGuildId = useAuthStore((state) => state.guildId);
  const selectedGuildId = guildId === undefined ? activeGuildId : guildId;
  const requireRoster = selectedGuildId === activeGuildId;
  const guild = useServerStore((state) =>
    selectedGuildId
      ? state.guilds.find((candidate) => candidate.id === selectedGuildId)
      : undefined,
  );
  const viewer = useServerStore((state) =>
    selectedGuildId && state.loadedGuildId === selectedGuildId
      ? state.members.find((member) => member.user_id === accountId)
      : undefined,
  );
  const snapshotsAuthoritative = useServerStore(
    (state) =>
      !!selectedGuildId &&
      state.accountId === accountId &&
      state.guildsLoaded &&
      state.guildsAuthorityRevision === state.authorityRevision &&
      (!requireRoster ||
        (state.loaded &&
          state.loadedGuildId === selectedGuildId &&
          state.membersAuthorityRevision === state.authorityRevision)),
  );

  return deriveProjectAuthority(accountId, guild, viewer, snapshotsAuthoritative, requireRoster);
}
